module.exports = __webpack_public_path__ + "img/02_02bg.216eda55.png";